import React from 'react'
import { Badge } from 'reactstrap'
import { saleProductStatusConf } from '../../fixed/commons/commonFunctions'

export const StatusMark = (props) => {
    const { className, title } = props
    return <div className={`${className}`} title={title} style={{ width: '1em', height: '1em', borderRadius: '50%' }} />

}
export const ProductBadges = (props) => {
    const { status, text = status, fullColorizedStatus } = props
    const { className } = saleProductStatusConf(status)
    return (
        <Badge color='light' className={`d-flex text-black mr-1 ${fullColorizedStatus ? className : ''}`} >
            {!fullColorizedStatus && <StatusMark className={className} title={status} />}
            <span className='ml-1' title={text}>{text}</span>
        </Badge>
    )
}
